import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/Index.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "/about",
        name: "About",
        component: () => import("@/views/About.vue"),
      },
      {
        path: "/config",
        name: "Configuracion",
        component: () => import("@/views/Configuracion.vue"),
      },
      {
        path: "/servicio",
        name: "SeleccionarServicio",
        component: () => import("@/views/SeleccionarServicio.vue"),
      },
      {
        path: "/servicio/:tiposervicio",
        name: "RegistroComensal",
        component: () => import("@/views/RegistrarServicio.vue"),
      },
      {
        path: "/estadisticas",
        name: "/estadisticas",
        component: () => import("@/views/Estadisticas.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
